import { motion } from 'framer-motion';
import { Calendar, RefreshCcw, ShieldCheck } from 'lucide-react';
import { FadeIn } from '@/components';

export function Guarantee() {
  return (
    <section className="section-shell bg-background">
      {/* Decorative gradient background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(16,185,129,0.08)_0%,transparent_70%)]" />

      <div className="section-container">
        <FadeIn direction="up" distance={24}>
          <div className="relative overflow-hidden border border-border bg-card p-6 text-card-foreground shadow-2xl sm:p-8 lg:p-14">
            {/* Corner brackets */}
            <svg
              className="absolute top-4 left-4 h-5 w-5 text-amber-500/30"
              viewBox="0 0 20 20"
              fill="none"
              role="img"
              aria-label="Decoração"
            >
              <path d="M0 6V0h6" stroke="currentColor" strokeWidth="1" />
            </svg>
            <svg
              className="absolute top-4 right-4 h-5 w-5 text-amber-500/30"
              viewBox="0 0 20 20"
              fill="none"
              role="img"
              aria-label="Decoração"
            >
              <path d="M20 6V0h-6" stroke="currentColor" strokeWidth="1" />
            </svg>
            <svg
              className="absolute bottom-4 left-4 h-5 w-5 text-amber-500/30"
              viewBox="0 0 20 20"
              fill="none"
              role="img"
              aria-label="Decoração"
            >
              <path d="M0 14v6h6" stroke="currentColor" strokeWidth="1" />
            </svg>
            <svg
              className="absolute bottom-4 right-4 h-5 w-5 text-amber-500/30"
              viewBox="0 0 20 20"
              fill="none"
              role="img"
              aria-label="Decoração"
            >
              <path d="M20 14v6h-6" stroke="currentColor" strokeWidth="1" />
            </svg>

            {/* Glossy overlay */}
            <div className="absolute inset-0 bg-linear-to-br from-primary/5 via-transparent to-primary/5 pointer-events-none" />

            <div className="flex flex-col items-center gap-10 md:flex-row md:gap-14">
              {/* Gold Seal Visual */}
              <div className="relative shrink-0 flex justify-center items-center">
                <motion.div
                  animate={{ rotate: 360 }}
                  transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
                  className="absolute -inset-2.5 border-2 border-dashed border-amber-500/20 opacity-50"
                  style={{
                    clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                  }}
                />

                <div className="relative z-10 flex h-44 w-44 items-center justify-center border-4 border-white/30 bg-linear-to-br from-amber-300 via-amber-500 to-amber-700 shadow-[0_0_50px_rgba(245,158,11,0.4)] dark:border-white/20 dark:from-amber-200 dark:via-amber-400 dark:to-amber-600 dark:shadow-[0_0_50px_rgba(245,158,11,0.3)] sm:h-52 sm:w-52 lg:h-64 lg:w-64">
                  <div className="text-center text-amber-950 px-4">
                    <ShieldCheck className="w-12 h-12 md:w-16 md:h-16 mx-auto mb-2 drop-shadow-md" />
                    <p className="text-3xl md:text-5xl font-black font-heading leading-none">7</p>
                    <p className="text-sm md:text-lg font-bold uppercase tracking-tighter">
                      Dias de
                    </p>
                    <p className="text-base font-black leading-none tracking-widest uppercase md:text-xl">
                      Garantia
                    </p>
                  </div>
                </div>
              </div>

              {/* Content Side */}
              <div className="flex flex-1 flex-col gap-6 text-center md:text-left">
                <p className="mb-4 font-mono text-xs tracking-[0.25em] text-amber-600 dark:text-amber-400 uppercase">
                  Protocolo de Segurança
                </p>

                <h2 className="section-title leading-tight">
                  Garantia Blindada <br />
                  <span className="text-primary">Guri dos Drones</span>
                </h2>

                <p className="text-base leading-relaxed text-muted-foreground sm:text-lg lg:text-xl">
                  Eu confio tanto no meu método que vou tirar todo o peso da decisão dos seus
                  ombros. Você tem <strong className="text-foreground font-bold">7 dias</strong>{' '}
                  para testar o curso completo.
                </p>

                <p className="text-base leading-relaxed text-muted-foreground sm:text-lg lg:text-xl">
                  Se você não gostar do conteúdo, da minha voz, ou achar que não é para você, basta
                  me enviar um único e-mail.
                  <span className="text-foreground font-bold">
                    {' '}
                    Devolvemos 100% do seu dinheiro
                  </span>
                  , centavo por centavo, sem perguntas e sem complicação.
                </p>

                <div className="flex flex-wrap justify-center gap-5 pt-3 md:justify-start">
                  <div className="flex items-center gap-2 font-mono text-xs font-semibold tracking-wider text-muted-foreground uppercase">
                    <Calendar className="w-4 h-4 text-primary" />
                    <span>Acesso Vitalício</span>
                  </div>
                  <div className="flex items-center gap-2 font-mono text-xs font-semibold tracking-wider text-muted-foreground uppercase">
                    <RefreshCcw className="w-4 h-4 text-primary" />
                    <span>Reembolso Integral</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
